import logoImage from "../../assest/images/logo-img.png"
import backgroundImg from "../../assest/images/signupbg2.png"
import { Link } from "react-router-dom"
import LastBox from "../../components/LastBox"
import backgroundImgDark from "../../assest/images/signupbg_dark.jpg"
import whiteLogoImage from "../../assest/images/whitelogo.png";



const ResetPassword = ({
    state,
    changePassword,
    changeValue,
    showPassword,
    showCPassword,
    handhandleShowPassword,
    getClassNames,
    isLoading,
    isSamePass,
    isDark,
    userlang
}) => {

    const { error, password, cpassword } = state;

    return (
        <section className="loginSec signUp" style={{ backgroundImage: `url(${isDark ?backgroundImgDark: backgroundImg})` }}>
            <div className="loginpart">
                <div className="container">
                    <div className="loginBox">
                        <div className="logoSec">
                       <Link to={'/' + userlang} className='comLogo'>
                                                       <img src={logoImage} alt="logo-img" />
                                                   </Link>
                                                   <Link to={'/' + userlang} className='whitelogo'><img src={whiteLogoImage} alt="logo-img" /></Link>
                            <h4>Set a new password</h4>
                        </div>
                        <form onSubmit={changePassword}>
                            <div className="fillDetails">
                                <ul>
                                    <li>
                                        <label className="commonLabel" htmlFor="">New Password</label>
                                        <input
                                            className={"commonInput " + getClassNames(2)}
                                            type={!showPassword ? 'password' : 'text'}
                                            placeholder=""
                                            name="password"
                                            value={password}
                                            onChange={changeValue}
                                        />
                                        <button className="btn btnShow" type="button">

                                            {
                                                showPassword ? <i className="fa-solid fa-eye-slash" onClick={(e) => handhandleShowPassword(e, 1)}></i> : <i className="fa-solid fa-eye" onClick={(e) => handhandleShowPassword(e, 1)}></i>
                                            }
                                        </button>
                                        {error && error.password && <span className="cus-err">{error.password}</span>}

                                    </li>
                                    <li>
                                        <div className="lineSpan">
                                            <span className={getClassNames(0)}></span>
                                            <span className={getClassNames(1)}></span>
                                            <span className={getClassNames(2)}></span>
                                        </div>
                                    </li>
                                    <li>
                                        <label className="commonLabel" htmlFor="">Confirm New Password</label>
                                        <input
                                            className={isSamePass ? "commonInput greenSpan" : "commonInput"}
                                            type={!showCPassword ? 'password' : 'text'}
                                            placeholder=""
                                            name="cpassword"
                                            value={cpassword}
                                            onChange={changeValue}
                                        />
                                        <button className="btn btnShow" type="button">
                                            {
                                                showCPassword ? <i className="fa-solid fa-eye-slash" onClick={(e) => handhandleShowPassword(e, 0)}></i> : <i className="fa-solid fa-eye" onClick={(e) => handhandleShowPassword(e, 0)}></i>
                                            }
                                        </button>
                                        {error && error.cpassword && <span className="cus-err">{error.cpassword}</span>}

                                    </li>

                                </ul>
                                <div className="remember">
                                    <div className="loginBtn">
                                        <button
                                            className="btn common-btn btn-login"
                                            type="submit"
                                            disabled={isLoading}
                                        >
                                            {isLoading ? "Loading..." : "Update Password"}
                                            {!isLoading && <i className="fa-solid fa-chevron-right"></i>}

                                        </button>
                                    </div>
                                    <div className="register">
                                        <p>Back To<Link className="comYellowa" to={'/en/login'}>Log in</Link></p>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <LastBox  userlang={userlang} />
                </div>
            </div>
        </section>
    )
}
export default ResetPassword;